import { GetRowIdParams, GridOptions } from '@ag-grid-community/core';
import { QueueSheetManagementRows } from '../../../interface/QueueSheetInterface';
import { NoRowsOverlay } from './gridOptions.styles';

export const getGridOptions = (t: (key: string) => string): GridOptions<QueueSheetManagementRows> => ({
  defaultColDef: {
    resizable: true,
  },
  pagination: true,
  paginationPageSize: 100,
  suppressMenuHide: false,
  noRowsOverlayComponent: NoRowsOverlay,
  noRowsOverlayComponentParams: { message: t('no-results-found') },
  popupParent: document.body,
  getRowId: (params: GetRowIdParams<QueueSheetManagementRows>) => params.data.bookingId,
  keepDetailRows: true,
});